import React, { useState } from 'react';
import FirstStep from './FirstStep';
import classes from './App.module.scss';
import SecondStep from './SecondStep';
import { validateFirstStep } from '../assets/utilities';
import emailjs from '@emailjs/browser';

const FormConsultant = ({ version }) => {
	const [details, setDetails] = useState({
		nume: '',
		email: '',
		telefon: '',
		ziua: '',
		ora: '',
	});
	const [step, setStep] = useState(1);
	const [spinner, setSpinner] = useState(false);
	const [errorMessage, setErrorMessage] = useState(false);

	// Handle change on input
	const handleChange = (e) => {
		const { name, value } = e.target;
		setDetails((prevState) => ({
			...prevState,
			[name]: value,
		}));
	};

	// Handle submit form
	const handleSubmit = async () => {
		const config = {
			method: 'post',
			headers: {
				'Content-Type': 'application/json',
				'Access-Control-Request-Headers': '*',
				'api-key':
					'EPFMERggoTLFoGPD3UvdLmsWiRBdahgRtYfWseAuZGpnCqBL0ARke8AfNCixWrAk',
			},
			body: JSON.stringify({
				collection: 'visit_requests',
				database: 'bman',
				dataSource: 'Cluster0',
				document: {
					nume_client: details.nume,
					email_client: details.email,
					telefon_client: details.telefon,
					rezervare_zi: details.ziua,
					rezervare_ora: `${details.ora}`,
				},
			}),
		};

		const adminTemplateParams = {
			nume_client: details.nume,
			email_client: details.email,
			telefon_client: details.telefon,
			rezervare_zi: details.ziua,
			rezervare_ora: `${details.ora}`,
		};

		const clientTemplateParams = {
			email_client: details.email,
			rezervare_zi: details.ziua,
			rezervare_ora: `${details.ora}`,
		};

		try {
			const response = await fetch(
				'https://sleepy-atoll-73441.herokuapp.com/https://data.mongodb-api.com/app/data-arjwr/endpoint/data/beta/action/insertOne',
				config
			);

			const data = await response.json();

			if (data.insertedId) {
				emailjs
					.send(
						'service_ofmpetu',
						'template_bk7v8vs',
						adminTemplateParams,
						'user_T4zJ3f0qyPDW9VIB6ajRT'
					)
					.then(
						(response) => {
							const validator = document.querySelector('#span-validator');

							validator.style.display = 'none';
							setSpinner(false);
							setStep(2);
						},
						(err) => {
							throw new Error(err);
						}
					);

				emailjs
					.send(
						'service_ofmpetu',
						'template_8saz9gc',
						clientTemplateParams,
						'user_T4zJ3f0qyPDW9VIB6ajRT'
					)
					.then(
						(response) => {},
						(err) => {
							throw new Error(err);
						}
					);
			} else {
				throw new Error(err);
			}
		} catch (error) {
			setSpinner(false);
			setErrorMessage(true);
		}
	};

	// Functionality and display of the button depending on the step
	const handleSteps = async () => {
		const validator = document.querySelector('#span-validator');

		if (step === 1) {
			if (
				details.ziua &&
				details.ora &&
				validateFirstStep(details.nume, details.email, details.telefon)
			) {
				validator.style.display = 'none';
				setSpinner(true);
				await handleSubmit();
			} else {
				validator.style.display = 'block';
			}
		}
	};

	const showButton = (step) => {
		if (step === 1) {
			return (
				<button
					type="button"
					className={`${classes['slider__button']}`}
					onClick={async () => await handleSteps()}
				>
					{spinner && <div className={classes['app-loader']}></div>}
					{!spinner && 'Programează-ți vizita'}
				</button>
			);
		} else {
			return (
				<button
					className={`${classes['slider__button']}`}
					onClick={(e) => e.target.closest("#app-formular-drawer").querySelector(".split-banner__trigger-form").click()}
				>
					Înapoi la site
				</button>
			);
		}
	};

	return (
		<>
			<div className={classes['single-product-content__custom-form']}>
				{step === 1 && (
					<FirstStep
						details={details}
						handleChange={handleChange}
						setStep={setStep}
						setDetails={setDetails}
						setErrorMessage={setErrorMessage}
						classes={classes}
					/>
				)}
				{step === 2 && <SecondStep classes={classes} />}
			</div>
			<div className={classes['button-submit-container']}>
				<span className="ta-center" id="span-validator">
					Toate câmpurile trebuie să aibă un conținut valid!
				</span>
				{errorMessage ? (
					<p className={`ta-center ${classes['app-error-message']}`}>
						Din motive necunoscute, formularul nu s-a trimis. Vă
						rugăm, reîncărcați pagina și reîncercați trimiterea
						formularului.
					</p>
				) : (
					showButton(step)
				)}
			</div>
		</>
	);
};

export default FormConsultant;
